import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box, Paper, Divider, TextField, InputAdornment, Dialog, Button, Typography, CircularProgress } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import "./Marketplace.Module.css";
import { toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { GetTokenFunc } from "../../utils/GetToken";
import { useDispatch, useSelector } from "react-redux";
import CommonDelete from "../CommonActions/CommonDelete";
import { StyledPagination } from "../../common/StyledPagination";
import { notifications } from "../../redux/action/Notification/notification";
import {
  GetAllProduct,
  setProductListingSearchOverride,
} from "../../redux/action/MarketPlace/Product-Filter";
import { MarketplaceEditReducer } from "../../redux/action/MarketPlace/Updatedata";
import PageLoader from "../CommonActions/PageLoader";
import {
  getDaysBetweenDates,
  countDaysfromTimeline,
  deepEqual,
  filterMultiples,
  AIRPORT_TIMESLOT_OPTIONS,
  isAirportMediaListing,
  getMaxTimeslotOptionsAfterMin,
  isDigitalVoucherProduct,
} from "./marketplaceUtils";
import MarketplaceFilters from "./MarketplaceFilters";
import MarketplaceHeader from "./MarketplaceHeader";
import MarketplaceTable from "./MarketplaceTable";
import EditProductDialog from "./EditProductDialog/EditProductDialog";
import { useCategories } from "../../Hooks/useCategories";
import { MULTIPLEX_MEDIA_SUBCATEGORY_ID, isMultiplexMedia } from "../../utils/adminMediaBuyingPath";
import { mapMultiplexDocToGridRows } from "../../utils/mapMultiplexDocToGridRows";
import { getMediaTypeFromProduct, MEDIA_TYPES } from "../../utils/mediaCalculations";

export let State = "";
export let Category = "";
export let Page = "";
export let TypeOfSelection = "";
export let PriceRevers = "";
export let ProductAnalysis = "";
export let Rating = "";
export let PriceRange = "";
export let SelectedCompany = "";
export let DateFilter = "";
export let StartingDateFilter = "";
export let EndingDateFilter = "";
export let ProductStatus = "";
/** Passed to AllProducts API: `"live"` | `"pending"` | `""` */
export let ListingScope = "";

const PRINT_MEDIA_SUBCATEGORY_NAMES = [
  "News Papers / Magazines",
  "Newspaper",
  "Newspapers",
  "Magazines",
  "Flyers",
  "Electricity bills",
  "Boarding Pass",
];

const isPrintMediaProduct = (product) => {
  if (!product) return false;
  const mediaCategory = String(product?.mediaCategory || "").toLowerCase().trim();
  if (mediaCategory === "print") return true;
  const mediaJourney = String(product?.mediaJourney || "").toLowerCase().trim();
  if (mediaJourney === "newspaper") return true;
  const subCategoryName = String(product?.ProductSubCategoryName || "").trim();
  const subCategory = String(product?.ProductSubCategory || "").trim();
  return (
    PRINT_MEDIA_SUBCATEGORY_NAMES.includes(subCategoryName) ||
    PRINT_MEDIA_SUBCATEGORY_NAMES.includes(subCategory)
  );
};

const isMultiplexMediaProduct = (product) => {
  if (!product) return false;
  return (
    product?.ProductSubCategory === MULTIPLEX_MEDIA_SUBCATEGORY_ID ||
    isMultiplexMedia(product) ||
    String(product?.mediaCategory || "").toLowerCase().trim() === "multiplex"
  );
};

const isDoohMediaProduct = (product) => {
  if (!product) return false;
  return getMediaTypeFromProduct(product) === MEDIA_TYPES.DOOH;
};

const isHoardingMediaProduct = (product) => {
  if (!product) return false;
  return getMediaTypeFromProduct(product) === MEDIA_TYPES.HOARDING;
};

const isDestructiveLiveProductStatus = (status) => {
  const value = String(status || "").trim();
  return value === "Delist" || value === "Rejected";
};

const Marketplace = ({
  forcedProductStatus = "",
  hideProductStatusFilter = false,
  showPendingQueueStatusFilter = false,
  showDelistedStatusFilter = false,
  listingScope = "",
  showProductSearch = false,
  defaultPendingQueueStatus = "",
}) => {
  const { products, loading } = useSelector((state) => state?.AllProducts);
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categories } = useCategories();
  const [isOpen, setIsOpen] = useState(false);
  const [AllCompanyName, setAllCompanyName] = useState([]);
  const [category, setCategory] = useState("");
  const [priceRevers, setPriceRevers] = useState("");
  const [productAnalysis, setProductAnalysis] = useState("");
  const [productStatus, setProductStatus] = useState(forcedProductStatus || "");
  const [state, setState] = useState("");
  const [priceRange, setPriceRange] = useState("");
  const [activeTab, setActiveTab] = useState(3);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [date, setDate] = useState("");
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [pendingQueueStatus, setPendingQueueStatus] = useState(defaultPendingQueueStatus);
  const [pid, setPid] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [showTextbox, setShowTextbox] = useState(false);
  const [ProductData, setProductData] = useState();
  const [ProductVariationData, setProductVariationData] = useState();
  const [UpdateRequestProduct, setUpdateRequestProduct] = useState();
  const [dateArr, setDateArr] = useState([]);
  const [value, setValueState] = useState();
  const [open, setOpen] = useState(false);

  /** Latest list filters for refetch actions; must stay in sync with state every render. */
  const marketplaceListFiltersRef = useRef(null);

  const toggle = () => setOpen(!open);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleStateChanges = (value) => {
    setState(value);
  };

  const handleClose = () => {
    setIsOpen(false);
    setOpen(false);
    setDateArr([]);
    setMultiplexExcelRowCount(null);
    setDoohExcelRowCount(null);
    setHoardingExcelRowCount(null);
    setOtpModalOpen(false);
    setOtpValue("");
    setOtpMaskedEmail("");
    setOtpTargetStatus("");
    pendingProductSaveRef.current = null;
  };

  const SecondsFieldArr = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
    100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160, 165, 170,
    175, 180,
  ];

  const handleDeleteClick = (product) => {
    setPid(product?._id);
    setIsDeleteModalOpen(true);
  };

  const GetProductUpdateRequest = async () => {
    await axios
      .get(`product/AllUpdateProductVariantionRequest`, {
        withCredentials: true,
      })
      .then((res) => {
        setUpdateRequestProduct(res?.data);
      })
      .catch((err) => { });
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [initialPaginationCount, setInitialPaginationCount] = useState(
    currentPage || 1
  );
  const [liveSearchInput, setLiveSearchInput] = useState("");
  const [liveSearchDebounced, setLiveSearchDebounced] = useState("");

  useLayoutEffect(() => {
    if (showProductSearch) {
      setProductListingSearchOverride("");
      setLiveSearchInput("");
      setLiveSearchDebounced("");
      setCurrentPage(1);
    } else {
      setProductListingSearchOverride(undefined);
    }
    return () => {
      if (showProductSearch) setProductListingSearchOverride(undefined);
    };
  }, [showProductSearch]);

  useEffect(() => {
    const handle = setTimeout(() => {
      setLiveSearchDebounced((liveSearchInput || "").trim());
    }, 400);
    return () => clearTimeout(handle);
  }, [liveSearchInput]);

  const handleDelete = async () => {
    try {
      setIsDeleteModalOpen(false);
      const response = await axios.post(
        `/api/v1/admin/DeleteProductOfCompanys?ProductId=${pid}`,
        {},
        {
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
          },
        }
      );

      // Assuming the deletion was successful, you can refetch the data here
      dispatch(GetAllProduct(marketplaceListFiltersRef.current));
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  const handleDeleteClose = () => {
    setIsDeleteModalOpen(false);
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleTabChange = (event) => {
    setActiveTab(Number(event.target.value));
  };

  const [formData, setFormData] = useState({
    productName: "",
    price: "",
    view: "",
    productType: "",
    mediaCategory: "",
    mediaJourney: "",
    location: "",
    listperiod: "",
    status: "",
    rejectionReason: "",
    reviewReason: "",
    reviewReasonNavigation: "",
    ProductsVariantions: [],
    ProductSubCategoryName: "",
    calender: dateArr,
    manualPoint: 0,
    ProductCategoryName: "",
  });

  const [MaxtimeslotArr, setMaxtimeslotArr] = useState([]);
  const [multiplexExcelRowCount, setMultiplexExcelRowCount] = useState(null);
  const [doohExcelRowCount, setDoohExcelRowCount] = useState(null);
  const [hoardingExcelRowCount, setHoardingExcelRowCount] = useState(null);
  const [updateProductId, setUpdateProductId] = useState("");
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpMaskedEmail, setOtpMaskedEmail] = useState("");
  const [otpResendIn, setOtpResendIn] = useState(0);
  const [otpTargetStatus, setOtpTargetStatus] = useState("");

  const inputRef = useRef(null);
  const originalListingStatusRef = useRef("");
  const pendingProductSaveRef = useRef(null);
  const otpVerifyingRef = useRef(false);
  const formDataRef = useRef(formData);
  formDataRef.current = formData;

  const needsLiveProductStatusOtp = (status) => {
    const next = String(status || "").trim();
    const prev = String(originalListingStatusRef.current || "").trim();
    return isDestructiveLiveProductStatus(next) && next !== prev;
  };

  const requestLiveProductStatusOtp = async ({ resend = false } = {}) => {
    const productId = updateProductId;
    const status =
      pendingProductSaveRef.current?.status ||
      String(formDataRef.current?.status || "").trim();
    if (!productId) {
      toast.error("Product not selected. Please try again.");
      return;
    }
    setOtpSending(true);
    try {
      const res = await axios.post(
        `/api/v1/admin/RequestLiveProductStatusOtp/${productId}`,
        { status },
        {
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
            "Content-Type": "application/json",
          },
        }
      );
      setOtpMaskedEmail(res?.data?.maskedEmail || "");
      setOtpTargetStatus(status);
      setOtpModalOpen(true);
      setOtpResendIn(30);
      toast.success(
        resend
          ? "A new verification code has been sent to your email."
          : res?.data?.message || "Verification code sent to your email."
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Could not send the verification code. Please try again."
      );
    } finally {
      setOtpSending(false);
    }
  };

  const saveProductAfterValidation = (saveArgs) => {
    if (needsLiveProductStatusOtp(formData.status)) {
      pendingProductSaveRef.current = {
        ...saveArgs,
        status: String(formData.status || "").trim(),
      };
      requestLiveProductStatusOtp();
      return;
    }
    dispatch(
      MarketplaceEditReducer(
        updateProductId,
        formData,
        0,
        saveArgs.variationStatus,
        saveArgs.calenderStatus,
        saveArgs.calenderData
      )
    );
    if (saveArgs.notify) {
      const AdminId = "650ac9c7b29820230639ab99";
      let receiver = ProductData?.SellerCompanyId?._id;
      let sender = AdminId;
      let message = `BXI Update Product Price And Quantity of ${ProductData?.ProductName}`;
      let type =
        formData?.productType === "Voucher" ? "Voucher" : "Product";
      dispatch(notifications(receiver, sender, message, type));
    }
    dispatch(GetAllProduct(marketplaceListFiltersRef.current));
    setIsOpen(false);
  };

  const confirmLiveProductStatusWithOtp = async () => {
    if (otpVerifyingRef.current) return;
    const code = String(otpValue || "").trim();
    if (!/^\d{6}$/.test(code)) {
      toast.error("Enter the 6-digit code sent to your email.");
      return;
    }
    const pending = pendingProductSaveRef.current;
    if (!pending) {
      toast.error("Please save the listing again to request a new code.");
      return;
    }
    otpVerifyingRef.current = true;
    setOtpVerifying(true);
    try {
      const result = await dispatch(
        MarketplaceEditReducer(
          updateProductId,
          { ...formDataRef.current, status: pending.status, otp: code },
          0,
          pending.variationStatus,
          pending.calenderStatus,
          pending.calenderData
        )
      );
      if (!result?.ok) {
        const data = result?.error?.response?.data || {};
        const remaining =
          typeof data.remainingAttempts === "number"
            ? ` ${data.remainingAttempts} attempt(s) left.`
            : "";
        toast.error((data.message || "Verification failed.") + remaining);
        if (result?.error?.response?.status === 403) {
          setOtpModalOpen(false);
          setOtpValue("");
          setOtpTargetStatus("");
          pendingProductSaveRef.current = null;
        }
        return;
      }
      if (pending.notify) {
        const AdminId = "650ac9c7b29820230639ab99";
        let receiver = ProductData?.SellerCompanyId?._id;
        let sender = AdminId;
        let message = `BXI Update Product Price And Quantity of ${ProductData?.ProductName}`;
        let type =
          formDataRef.current?.productType === "Voucher" ? "Voucher" : "Product";
        dispatch(notifications(receiver, sender, message, type));
      }
      toast.success("Listing updated successfully.");
      setOtpModalOpen(false);
      setOtpValue("");
      setOtpMaskedEmail("");
      setOtpTargetStatus("");
      pendingProductSaveRef.current = null;
      dispatch(GetAllProduct(marketplaceListFiltersRef.current));
      setIsOpen(false);
    } finally {
      otpVerifyingRef.current = false;
      setOtpVerifying(false);
    }
  };

  const UpdateProduct = async () => {
    const isPrintMediaEdit = isPrintMediaProduct({
      ...ProductData,
      ...formData,
    });

    if (
      formData.status === "Review" &&
      (formData.reviewReason === undefined || formData.reviewReason === "")
    ) {
      toast.error("Please Fill the Review Reason field");
      return;
    }
    if (
      formData.status === "Review" &&
      (formData.reviewReason && formData.reviewReasonNavigation === "" || formData.reviewReasonNavigation === undefined)
    ) {
      toast.error("Please Fill the Navigation Status field");
      return;
    }

    if (
      formData.status === "Rejected" &&
      (formData.rejectionReason === undefined ||
        String(formData.rejectionReason).trim() === "")
    ) {
      toast.error("Please Fill the Reason for rejection field");
      return;
    }

    if (
      deepEqual(formData?.ProductsVariantions, ProductVariationData) &&
      formData?.productType !== "Media"
    ) {
      saveProductAfterValidation({ variationStatus: true });
    } else if (
      deepEqual(formData?.ProductsVariantions, ProductVariationData) &&
      deepEqual(formData?.calender, dateArr) &&
      formData?.productType === "Media"
    ) {
      saveProductAfterValidation({ variationStatus: false });
    } else {
      // is not matched
      const formDataVariations = formData?.ProductsVariantions ?? [];
      const productVariationData = ProductVariationData ?? [];
      const safeDateArr = Array.isArray(dateArr) ? dateArr : [];
      let allVariationsPassConditions = true;

      const MaxDaysTobeadded = isPrintMediaEdit
        ? 0
        : countDaysfromTimeline(
          formData?.mediaVariation?.maxOrderQuantitytimeline,
          formData?.mediaVariation?.Timeline,
          formData?.mediaVariation
        );

      let Totaldays = 0;
      if (
        formData?.ProductCategoryName === "MediaOffline" ||
        formData?.ProductCategoryName === "News Papers / Magazines"
      ) {
        safeDateArr.map((item) => {
          return (Totaldays += getDaysBetweenDates(
            item.startDate,
            item.endDate,
            false
          ));
        });
      } else {
        Totaldays =
          safeDateArr?.at(0)?.startDate === undefined
            ? 0
            : getDaysBetweenDates(
              safeDateArr?.at(0)?.startDate,
              safeDateArr?.at(-1)?.endDate,
              true
            );
      }

      for (let i = 0; i < formDataVariations.length; i++) {
        const currentVariation = formDataVariations[i];
        const hsnRaw =
          currentVariation?.HSN != null && currentVariation?.HSN !== ""
            ? String(currentVariation.HSN).trim()
            : "";

        if (hsnRaw) {
          if (!/^\d{4}$|^\d{6}$|^\d{8}$/.test(hsnRaw)) {
            toast.error(
              `HSN code of Variation ${i + 1} must be 4, 6, or 8 digits`
            );
            allVariationsPassConditions = false;
            break;
          }
          if (hsnRaw.startsWith("0") || /^0+$/.test(hsnRaw)) {
            toast.error(`HSN code of Variation ${i + 1} is invalid`);
            allVariationsPassConditions = false;
            break;
          }
        }

        if (
          (currentVariation.DiscountedPrice >
            currentVariation?.PricePerUnit) &&
          formData?.productType === "Product"
        ) {
          toast.error(
            `DiscountedPrice of Variation ${i + 1
            } should not be greater than the PricePerUnit`
          );
          allVariationsPassConditions = false;
          break;
        } else if (
          (currentVariation.MaxOrderQuantity <
            productVariationData[i]?.MinOrderQuantity ||
            currentVariation.MaxOrderQuantity <
            currentVariation.MinOrderQuantity) &&
          formData?.productType !== "Media" &&
          !isDigitalVoucherProduct({ ...ProductData, ...formData })
        ) {
          toast.error(
            `MaxOrderQuantity of Variation ${i + 1
            } should not be less than the MinOrderQuantity`
          );
          allVariationsPassConditions = false;
          break;
        } else if (
          (currentVariation.MaxOrderQuantity <
            productVariationData[i]?.MinOrderQuantity ||
            currentVariation.MaxOrderQuantity <
            currentVariation.MinOrderQuantity) &&
          formData?.ProductSubCategoryName !== "Airport Screens" &&
          !isDoohMediaProduct({ ...ProductData, ...formData }) &&
          !isHoardingMediaProduct({ ...ProductData, ...formData }) &&
          formData?.productType === "Media"
        ) {
          toast.error(
            `MaxOrderQuantity of Variation ${i + 1
            } should not be less than the MinOrderQuantity`
          );
          allVariationsPassConditions = false;
          break;
        } else if (
          currentVariation.MaxOrderQuantity !==
          currentVariation.MinOrderQuantity &&
          formData?.ProductSubCategoryName === "Airport Screens" &&
          formData?.productType === "Media"
        ) {
          toast.error(
            `MaxOrderQuantity of Variation ${i + 1
            } should be same as the MinOrderQuantity`
          );
          allVariationsPassConditions = false;
          break;
        } else if (
          Number(currentVariation.maxTimeslotSeconds) <
          Number(currentVariation.minTimeslotSeconds) &&
          formData?.productType === "Media"
        ) {
          toast.error(
            `Max Timeslot Seconds of Variation ${i + 1
            } should not be less than the Min Timeslot Seconds`
          );
          allVariationsPassConditions = false;
          break;
        } else if (
          (Totaldays < MaxDaysTobeadded &&
            formData?.productType === "Media" &&
            (formData?.ProductCategoryName === "MediaOffline" ||
              formData?.ProductCategoryName === "News Papers / Magazines")) &&
          !isPrintMediaEdit &&
          !formData?.ProductCategoryName === "Multiplex ADs"
        ) {
          toast.error(
            `Please Select Dates According to your timeline you need to add ${MaxDaysTobeadded} or more days and you have added ${Totaldays} days`
          );
          allVariationsPassConditions = false;
          break;
        } else if (
          !(Number(Totaldays) >= Number(MaxDaysTobeadded)) &&
          formData?.productType === "Media" &&
          formData?.ProductCategoryName === "MediaOnline" &&
          !isPrintMediaEdit &&
          !formData?.ProductCategoryName === "Multiplex ADs"
        ) {
          toast.error(
            `Please Select Dates According to your timeline you need to add ${MaxDaysTobeadded} or more days and you have added ${Totaldays} days`
          );
          allVariationsPassConditions = false;
          break;
        }
      }

      if (allVariationsPassConditions) {
        let variationStatus = deepEqual(
          formData?.ProductsVariantions,
          ProductVariationData
        )
          ? false
          : true;
        let calenderStatus = formData?.calender
          ? deepEqual(formData?.calender, dateArr)
            ? false
            : true
          : false;
        saveProductAfterValidation({
          variationStatus,
          calenderStatus,
          calenderData: dateArr,
          notify: true,
        });
      }
    }
  };


  useEffect(() => {
    if (inputRef.current !== null) {
      inputRef.current.setSelectionRange(
        inputRef.current.selectionStart,
        inputRef.current.selectionEnd
      );
    }
  });

  useEffect(() => {
    if (otpResendIn <= 0) return;
    const t = setTimeout(() => setOtpResendIn((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [otpResendIn]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (value === "Rejected" || value === "Review") {
      setShowTextbox(true);
    } else {
      setShowTextbox(false);
    }
  };

  const handleVariationChange = (variationIndex, field, value) => {
    setFormData((prevFormData) => {
      const updatedVariations = [...prevFormData.ProductsVariantions];

      // Convert the value to a number using parseInt
      const numericValue = parseInt(value, 10);

      if (
        field === "maxTimeslotSeconds" ||
        field === "minTimeslotSeconds" ||
        field === "maxOrderQuantityunit" ||
        field === "minOrderQuantityunit"
      ) {
        updatedVariations[variationIndex] = {
          ...updatedVariations[variationIndex],
          [field]: value,
        };
      } else if (field === "VariantName") {
        const trimmed = String(value ?? "")
          .replace(/[\u0000-\u001F\u007F]/g, "")
          .trimStart();
        updatedVariations[variationIndex] = {
          ...updatedVariations[variationIndex],
          VariantName: trimmed.slice(0, 120),
        };
      } else if (field === "unit") {
        updatedVariations[variationIndex] = {
          ...updatedVariations[variationIndex],
          unit: String(value ?? "").slice(0, 60),
        };
      } else if (field === "timeline") {
        const timelineValue = String(value ?? "").trim().slice(0, 30);
        updatedVariations[variationIndex] = {
          ...updatedVariations[variationIndex],
          timeline: timelineValue,
          minOrderQuantitytimeline: timelineValue,
          maxOrderQuantitytimeline: timelineValue,
        };
      } else if (field === "HSN") {
        const hsnValue = String(value ?? "")
          .replace(/\D/g, "")
          .slice(0, 8);
        updatedVariations[variationIndex] = {
          ...updatedVariations[variationIndex],
          HSN: hsnValue,
        };
      } else {
        updatedVariations[variationIndex] = {
          ...updatedVariations[variationIndex],
          [field]: numericValue,
        };
      }

      return {
        ...prevFormData,
        ProductsVariantions: updatedVariations,
      };
    });
  };
  const handleKeyDown = (e) => {
    // Allow numbers, decimal point, and navigation keys
    if (
      !/^[0-9.]$/.test(e.key) &&
      !["Backspace", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  const getResolvedLocation = (product) => {
    if (!product) return "";
    const normalize = (value) => {
      if (!value) return "";
      if (typeof value === "object" && !Array.isArray(value)) {
        const objectBased = [
          value.location,
          value.city,
          value.state,
          value.region,
          value.landmark,
        ]
          .filter(Boolean)
          .map((part) => String(part).trim())
          .filter(Boolean)
          .join(", ");
        return objectBased;
      }
      if (Array.isArray(value)) {
        if (!value.length) return "";
        if (typeof value[0] === "object" && value[0] !== null) {
          const objectBased = value
            .map((item) => item?.city || item?.location || item?.state || item?.region)
            .filter(Boolean)
            .join(", ");
          return objectBased || "";
        }
        return value.filter(Boolean).join(", ");
      }
      return String(value).trim();
    };

    const mediaVariationLocations = Array.isArray(product?.MediaVariation)
      ? product.MediaVariation.map((row) => row?.location).filter(Boolean)
      : [];

    const candidates = [
      product?.LocationDetails?.city,
      product?.GeographicalData?.city,
      product?.Location,
      product?.location,
      product?.GeographicalData?.state,
      product?.GeographicalData?.region,
      ...mediaVariationLocations,
      product?.ProductsVariantions?.[0]?.location,
      product?.mediaVariation?.location,
      product?.City,
      product?.State,
      product?.LocationDetails?.location,
      product?.LocationDetails?.state,
      product?.LocationDetails,
      product?.GeographicalData?.location,
      product?.GeographicalData,
    ];

    for (const item of candidates) {
      const resolved = normalize(item);
      if (resolved) return resolved;
    }
    return "";
  };

  const resolveMultiplexExcelRowCount = async (product) => {
    if (!product) return null;
    if (product?.MultiplexScreenId) {
      try {
        const res = await axios.get(
          `product/MultiplexScreenGetById/${product.MultiplexScreenId}`,
          { withCredentials: true },
        );
        const rows = mapMultiplexDocToGridRows(res?.data?.data);
        if (rows.length > 0) return rows.length;
      } catch {
      }
    }
    if (Array.isArray(product?.MediaVariation) && product.MediaVariation.length > 0) {
      return product.MediaVariation.length;
    }
    return null;
  };

  const formatDigitalAdsScreenLocation = (screen) =>
    [screen?.location, screen?.city, screen?.state]
      .map((part) => String(part ?? "").trim())
      .filter(Boolean)
      .join(", ");

  const collectDigitalAdsScreenMeta = (screens) => {
    if (!Array.isArray(screens) || screens.length === 0) {
      return { excelRowCount: null, screenLocation: "" };
    }
    const screenLocations = screens
      .map(formatDigitalAdsScreenLocation)
      .filter(Boolean);
    return {
      excelRowCount: screens.length,
      screenLocation: [...new Set(screenLocations)].slice(0, 5).join("; "),
    };
  };

  const getDoohResolvedLocation = (product, screenLocation = "") => {
    if (String(screenLocation ?? "").trim()) {
      return String(screenLocation).trim();
    }
    return getResolvedLocation(product);
  };

  const resolveHoardingExcelRowCount = async (product) => {
    if (!product) return null;

    if (product?.Hoarding_list_id) {
      try {
        const res = await axios.get(
          `product/HoardingListGetById/${product.Hoarding_list_id}`,
          { withCredentials: true },
        );
        const hoardings =
          res?.data?.hoardings_list ||
          res?.data?.data?.hoardings_list ||
          [];
        if (Array.isArray(hoardings) && hoardings.length > 0) {
          return hoardings.length;
        }
      } catch {
      }
    }

    if (product?._id) {
      try {
        const res = await axios.get(
          `product/get_hoarding_products/${product._id}`,
          { withCredentials: true },
        );
        const data = res?.data?.data || {};
        const hoardings =
          data?.HoardingLists?.hoardings_list ||
          data?.hoardings_list ||
          [];
        if (Array.isArray(hoardings) && hoardings.length > 0) {
          return hoardings.length;
        }
      } catch {
      }
    }

    if (Array.isArray(product?.hoardings_list) && product.hoardings_list.length > 0) {
      return product.hoardings_list.length;
    }
    if (Array.isArray(product?.MediaVariation) && product.MediaVariation.length > 0) {
      return product.MediaVariation.length;
    }
    return null;
  };

  const resolveDoohEditMeta = async (product) => {
    if (!product) return { excelRowCount: null, location: "" };

    let excelRowCount = null;
    let screenLocation = "";

    if (product?.DigitalAds_screen_id) {
      try {
        const res = await axios.get(
          `product/DigitalAdsScreenGetById/${product.DigitalAds_screen_id}`,
          { withCredentials: true },
        );
        const meta = collectDigitalAdsScreenMeta(res?.data?.data?.digitalAdsScreens);
        excelRowCount = meta.excelRowCount;
        screenLocation = meta.screenLocation;
      } catch {
      }
    }

    if (excelRowCount == null && product?._id) {
      try {
        const res = await axios.get(
          `product/get_digitalads_products/${product._id}`,
          { withCredentials: true },
        );
        const data = res?.data?.data || {};
        const screens =
          data?.DigitalAdsScreens?.digitalAdsScreens ||
          data?.digitalAdsScreens ||
          data?.screens ||
          [];
        const meta = collectDigitalAdsScreenMeta(screens);
        excelRowCount = meta.excelRowCount;
        if (!screenLocation) screenLocation = meta.screenLocation;
      } catch {
      }
    }

    if (excelRowCount == null && Array.isArray(product?.MediaVariation) && product.MediaVariation.length > 0) {
      excelRowCount = product.MediaVariation.length;
    }

    return {
      excelRowCount,
      location: getDoohResolvedLocation(product, screenLocation),
    };
  };

  const setDataEditButton = async (productId) => {
    const productToEdit = products?.products?.find(
      (product) => product?._id === productId
    );
    setProductData(productToEdit);

    setUpdateProductId(productId);

    if (productToEdit) {
      let resolvedLocation = getResolvedLocation(productToEdit);

      if (isMultiplexMediaProduct(productToEdit)) {
        setMultiplexExcelRowCount(await resolveMultiplexExcelRowCount(productToEdit));
        setDoohExcelRowCount(null);
        setHoardingExcelRowCount(null);
      } else if (isDoohMediaProduct(productToEdit)) {
        setMultiplexExcelRowCount(null);
        setHoardingExcelRowCount(null);
        const doohMeta = await resolveDoohEditMeta(productToEdit);
        setDoohExcelRowCount(doohMeta.excelRowCount);
        resolvedLocation = doohMeta.location || resolvedLocation;
      } else if (isHoardingMediaProduct(productToEdit)) {
        setMultiplexExcelRowCount(null);
        setDoohExcelRowCount(null);
        setHoardingExcelRowCount(await resolveHoardingExcelRowCount(productToEdit));
      } else {
        setMultiplexExcelRowCount(null);
        setDoohExcelRowCount(null);
        setHoardingExcelRowCount(null);
      }

      const variationsWithHsn = (productToEdit?.ProductsVariantions || []).map(
        (variant, index) => {
          if (index !== 0) return variant;
          const variantHsn = variant?.HSN;
          const mediaHsn = productToEdit?.mediaVariation?.HSN;
          if (
            (variantHsn == null || variantHsn === "") &&
            mediaHsn != null &&
            mediaHsn !== ""
          ) {
            return { ...variant, HSN: mediaHsn };
          }
          return variant;
        }
      );

      setFormData({
        productName: productToEdit?.ProductName,
        ProductsVariantions: variationsWithHsn,
        mediaVariation: productToEdit?.mediaVariation,
        price: productToEdit?.ProductsVariantions[0]?.DiscountedPrice,
        listperiod:
          productToEdit?.ListingType === "Product" ||
            productToEdit?.ListingType === "Media"
            ? productToEdit?.listperiod
            : productToEdit?.ListingType === "Voucher"
              ? productToEdit?.ListThisProductForAmount
              : null,
        view: productToEdit?.ProductAnalysis?.ProductViewCount,
        productType: productToEdit?.ListingType,
        mediaCategory: productToEdit?.mediaCategory || "",
        mediaJourney: productToEdit?.mediaJourney || "",
        location: resolvedLocation,
        status: productToEdit?.ProductUploadStatus,
        rejectionReason: productToEdit?.rejectionReason,
        reviewReason: productToEdit?.reviewReason,
        reviewReasonNavigation: productToEdit?.reviewReasonNavigation,
        manualPoint: productToEdit?.ManualPoint ?? 0,
        ProductSubCategoryName: productToEdit?.ProductSubCategoryName,
        ProductSubCategory: productToEdit?.ProductSubCategory,
        calender: productToEdit?.calender,
        ProductCategoryName:
          productToEdit?.ListingType === "Media"
            ? productToEdit?.ProductCategoryName
            : "",
        voucherDeliveryType: productToEdit?.voucherDeliveryType ?? "",
        redemptionType: productToEdit?.redemptionType ?? "",
      });
      originalListingStatusRef.current =
        productToEdit?.ProductUploadStatus || "";
      setDateArr(productToEdit?.calender);
      setProductVariationData(variationsWithHsn);
    }
  };

  useEffect(() => {
    if (products && products?.count !== undefined) {
      setInitialPaginationCount(products?.count);
    }
  }, [products?.count]);

  Page = currentPage;
  Category = category;
  TypeOfSelection = activeTab;
  PriceRevers = priceRevers;
  ProductAnalysis = productAnalysis;
  State = state;
  PriceRange = priceRange;
  SelectedCompany = selectedCompany;
  DateFilter = date;
  StartingDateFilter = startingDate;
  EndingDateFilter = endingDate;
  ProductStatus = productStatus;
  ListingScope = listingScope;

  marketplaceListFiltersRef.current = {
    category,
    currentPage,
    activeTab,
    priceRevers,
    productAnalysis,
    state,
    priceRange,
    selectedCompany,
    date,
    startingDate,
    endingDate,
    productStatus,
    pendingQueueStatus,
    listingScope,
    liveSearchDebounced,
    showProductSearch,
  };

  const filterByCompany = async () => {
    if (String(listingScope || "").trim().toLowerCase() === "live") {
      try {
        const statusParam = encodeURIComponent(
          forcedProductStatus || productStatus || "Approved"
        );
        const { data } = await axios.post(
          `AdminCompanyDetails/AllProducts?ProductCategory=&ProductType=&PriceRevers=&ProductAnalysis=&SelectedCompany=&DateFilter=&StartingDate=&EndingDate=&ProductStatus=${statusParam}&PendingQueueStatus=&ProductLocationState=&PriceRange=&page=1&limit=5000&Search=&listingScope=live`,
          { withCredentials: true }
        );
        const products = Array.isArray(data?.products) ? data.products : [];
        const byName = new Map();
        for (const p of products) {
          const companyName = String(
            p?.SellerCompanyName || p?.SellerCompanyId?.companyName || ""
          ).trim();
          if (!companyName || byName.has(companyName.toLowerCase())) continue;
          byName.set(companyName.toLowerCase(), {
            _id: p?.SellerCompanyId?._id || p?.SellerCompanyId || companyName,
            companyName,
          });
        }
        const companies = Array.from(byName.values()).sort((a, b) =>
          a.companyName.localeCompare(b.companyName)
        );
        setAllCompanyName(companies);
        setSelectedCompany((prev) => {
          if (!prev) return prev;
          const stillPresent = companies.some(
            (c) => c.companyName === prev
          );
          return stillPresent ? prev : "";
        });
        return;
      } catch (err) {
      }
    }

    const params = listingScope ? { listingScope } : {};
    await axios
      .get(`product/get_allproducts_bycompany`, { params, withCredentials: true })
      .then((res) => {
        setAllCompanyName(res.data);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    filterByCompany();
    GetProductUpdateRequest();
  }, [listingScope, forcedProductStatus]);

  useEffect(() => {
    if (forcedProductStatus) {
      setProductStatus(forcedProductStatus);
      setCurrentPage(1);
    }
  }, [forcedProductStatus]);

  useEffect(() => {
    if (showProductSearch) {
      setProductListingSearchOverride(liveSearchDebounced);
    }
    dispatch(
      GetAllProduct({
        category,
        currentPage,
        activeTab,
        priceRevers,
        productAnalysis,
        state,
        priceRange,
        selectedCompany,
        date,
        startingDate,
        endingDate,
        productStatus,
        pendingQueueStatus,
        listingScope,
        liveSearchDebounced,
        showProductSearch,
      })
    );
  }, [
    dispatch,
    category,
    currentPage,
    activeTab,
    priceRevers,
    productAnalysis,
    state,
    priceRange,
    selectedCompany,
    date,
    startingDate,
    endingDate,
    productStatus,
    pendingQueueStatus,
    listingScope,
    showProductSearch,
    liveSearchDebounced,
  ]);

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
  };

  const handleEditClick = (product) => {
    setDataEditButton(product?._id);
    const minTimeslot = product?.ProductsVariantions?.at(0)?.minTimeslotSeconds;
    if (minTimeslot) {
      const slotOptions = isAirportMediaListing(product)
        ? AIRPORT_TIMESLOT_OPTIONS
        : SecondsFieldArr;
      setMaxtimeslotArr(
        isAirportMediaListing(product)
          ? getMaxTimeslotOptionsAfterMin(minTimeslot, slotOptions)
          : filterMultiples(slotOptions, Number(minTimeslot)),
      );
    }
    setIsOpen(true);
  };

  const handleViewClick = (product) => {
    const id = product?._id;
    if (!id) return;

    const listingType = product?.ListingType;
    const voucherType = product?.VoucherType;
    const productSubCategory = product?.ProductSubCategory;

    if (listingType === "Voucher") {
      navigate(
        voucherType === "Value Voucher / Gift Cards "
          ? `valueandgiftvoucher/${id}`
          : `spacificvoucher/${id}`
      );
      return;
    }

    if (listingType === "Media") {
      const isMultiplexRoute =
        productSubCategory === MULTIPLEX_MEDIA_SUBCATEGORY_ID ||
        String(product?.ProductCategoryName || "").trim() === "Multiplex ADs";
      if (isMultiplexRoute) {
        navigate(`multiplexmediaviewproduct/${id}`, { state: { type: "Media" } });
        return;
      }
      const mediaType = getMediaTypeFromProduct(product);
      if (mediaType === MEDIA_TYPES.HOARDING || mediaType === MEDIA_TYPES.DOOH) {
        navigate(`hoardingmediaviewproduct/${id}`, { state: { type: "Media" } });
        return;
      }
      navigate(`mediaviewproduct/${id}`, { state: { type: "Media" } });
      return;
    }

    navigate(`viewproduct/${id}`);
  };

  return (
    <Paper
      elevation={0}
      className="marketplace-page"
      sx={{
        width: "100%",
        minHeight: "100%",
        overflowY: "auto",
        backgroundColor: "#FFFFFF",

      }}
    >
      {showProductSearch && (
        <Box sx={{ px: 2, pt: 2, pb: 0 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by product name, company, or ID…"
            value={liveSearchInput}
            onChange={(e) => {
              setLiveSearchInput(e.target.value);
              setCurrentPage(1);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              maxWidth: { sm: 560, md: 720 },
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                bgcolor: "grey.50",
              },
            }}
          />
        </Box>
      )}
      <MarketplaceHeader activeTab={activeTab} onTabChange={handleTabChange} />
      <MarketplaceFilters
        category={category}
        setCategory={setCategory}
        categoryOptions={categories}
        selectedCompany={selectedCompany}
        handleCompanyChange={handleCompanyChange}
        AllCompanyName={AllCompanyName}
        priceRevers={priceRevers}
        setPriceRevers={setPriceRevers}
        productAnalysis={productAnalysis}
        setProductAnalysis={setProductAnalysis}
        state={state}
        handleStateChanges={handleStateChanges}
        date={date}
        setDate={setDate}
        startingDate={startingDate}
        setStartingDate={setStartingDate}
        endingDate={endingDate}
        setEndingDate={setEndingDate}
        productStatus={productStatus}
        setProductStatus={setProductStatus}
        hideProductStatusFilter={hideProductStatusFilter}
        forcedProductStatus={forcedProductStatus}
        showPendingQueueStatusFilter={showPendingQueueStatusFilter}
        showDelistedStatusFilter={showDelistedStatusFilter}
        pendingQueueStatus={pendingQueueStatus}
        setPendingQueueStatus={(value) => {
          setPendingQueueStatus(value);
          setCurrentPage(1);
        }}
        priceRange={priceRange}
        setPriceRange={setPriceRange}
        searchQuery={liveSearchInput}
        setSearchQuery={(value) => {
          setLiveSearchInput(value);
          setCurrentPage(1);
        }}
      />
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5, width: "100%" }}>
          <PageLoader />
        </Box>
      ) : (
        <MarketplaceTable
          products={products}
          productAnalysis={productAnalysis}
          updateRequestProduct={UpdateRequestProduct}
          onEditClick={handleEditClick}
          onViewClick={handleViewClick}
          onDeleteClick={handleDeleteClick}
        />
      )}
      
      <EditProductDialog
        open={isOpen}
        onClose={handleClose}
        disableEnforceFocus={otpModalOpen}
        formData={formData}
        onInputChange={handleInputChange}
        onVariationChange={handleVariationChange}
        onKeyDown={handleKeyDown}
        onSave={UpdateProduct}
        dateArr={dateArr}
        setDateArr={setDateArr}
        calendarOpen={open}
        setCalendarOpen={setOpen}
        calendarValue={value}
        setCalendarValue={setValueState}
        maxtimeslotArr={MaxtimeslotArr}
        setMaxtimeslotArr={setMaxtimeslotArr}
        inputRef={inputRef}
        isPrintMedia={isPrintMediaProduct({ ...ProductData, ...formData })}
        isMultiplexMedia={isMultiplexMediaProduct({ ...ProductData, ...formData })}
        multiplexExcelRowCount={multiplexExcelRowCount}
        isDoohMedia={isDoohMediaProduct({ ...ProductData, ...formData })}
        doohExcelRowCount={doohExcelRowCount}
        isHoardingMedia={isHoardingMediaProduct({ ...ProductData, ...formData })}
        hoardingExcelRowCount={hoardingExcelRowCount}
        isDigitalVoucher={isDigitalVoucherProduct({ ...ProductData, ...formData })}
      />
      <Dialog
        open={otpModalOpen}
        onClose={() => {
          if (!otpVerifying) {
            setOtpModalOpen(false);
            setOtpValue("");
          }
        }}
        maxWidth="xs"
        fullWidth
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
      >
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontWeight: 600, fontSize: "16px", mb: 1 }}>
            Verify to {otpTargetStatus === "Rejected" ? "reject" : "delist"} this listing
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#666", mb: 2 }}>
            For security, delisting or rejecting a listing requires a verification code.
            {otpMaskedEmail
              ? ` We emailed a 6-digit code to ${otpMaskedEmail}.`
              : " We emailed a 6-digit code to your registered admin email."}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            value={otpValue}
            onChange={(e) =>
              setOtpValue(e.target.value.replace(/\D/g, "").slice(0, 6))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                confirmLiveProductStatusWithOtp();
              }
            }}
            placeholder="Enter 6-digit code"
            inputProps={{
              inputMode: "numeric",
              maxLength: 6,
              style: {
                textAlign: "center",
                letterSpacing: "6px",
                fontSize: "20px",
              },
            }}
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <Button
              variant="contained"
              color="error"
              onClick={confirmLiveProductStatusWithOtp}
              disabled={otpVerifying || otpValue.length !== 6}
            >
              {otpVerifying ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : otpTargetStatus === "Rejected" ? (
                "Verify & Reject"
              ) : (
                "Verify & Delist"
              )}
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOtpModalOpen(false);
                setOtpValue("");
              }}
              disabled={otpVerifying}
            >
              Cancel
            </Button>
          </Box>
          <Button
            size="small"
            onClick={() => requestLiveProductStatusOtp({ resend: true })}
            disabled={otpSending || otpResendIn > 0}
            sx={{ mt: 1.5, textTransform: "none" }}
          >
            {otpResendIn > 0
              ? `Resend code in ${otpResendIn}s`
              : otpSending
                ? "Sending..."
                : "Resend code"}
          </Button>
        </Box>
      </Dialog>
      <CommonDelete
        open={isDeleteModalOpen}
        onClose={handleDeleteClose}
        // onDelete={handleDelete}
        onDelete={() => {
          handleDelete(pid);
        }}
        text="Are you sure you want to delete this Product?"
        ButtonLabel="Delete"
        cancelButtonLabel="Cancel"
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: {
            xl: "100%",
            lg: "100%",
            md: "100%",
            sm: "100%",
            xs: "100%",
          },
          mx: "auto",
        }}
        mt={2}
      >
        <Stack>
          <StyledPagination
            size="medium"
            count={initialPaginationCount}
            color="primary"
            showFirstButton
            showLastButton
            page={currentPage}
            onChange={handlePageChange}
            strokeWidth={currentPage}
          />
        </Stack>
      </Box>
    </Paper>
  );
};

export default Marketplace;
